<template>
  <a :href="link" target="_blank" :alt="alt" :title="title"><i :class="fa_class"></i></a>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'socialIcon',
  props: [
    'object',
    'name'
  ],
  computed: {
    title: function () {
      return this.company + ' on ' + this.name
    },
    fa_class: function () {
      return 'socialicons fa fa-' + this.object.fa + ' fa-lg'
    },
    link: function () {
      return this.object.link
    },
    alt: function () {
      return this.company + ' ' + this.name + ' Page'
    },
    ...mapState({
      company: state => state.config.company
    })
  }
}
</script>

<!-- TODO the background images maybe shouldn't be in a sprite external to this component -->
<style>

  .socialicons{
    color: #9D3439;
    text-shadow: 0px 0px 4px #000;
  }
  .socialicons:hover{
    color: #6B8F53;
  }
</style>



// WEBPACK FOOTER //
// SocialIcon.vue?f1b389b8